import ProcessStep from "@/components/ProcessStep";

export default function NavigatingExperience() {
  const steps = [
    {
      stepNumber: "Step 01",
      title: "Discover a World of Possibilities",
      description: "Your journey begins with exploring our carefully curated property listings. Use our intuitive search tools to filter properties based on your preferences."
    },
    {
      stepNumber: "Step 02",
      title: "Narrowing Down Your Choices",
      description: "Once you've found properties that catch your eye, save them to your account or make a shortlist. This allows you to compare and revisit your favorites."
    },
    {
      stepNumber: "Step 03",
      title: "Personalized Guidance",
      description: "Have questions about a property or need more information? Our dedicated team of real estate experts is just a call or message away."
    },
    {
      stepNumber: "Step 04",
      title: "See It for Yourself",
      description: "Arrange viewings of the properties you're interested in. We'll coordinate with the property owners and accompany you to ensure you get a firsthand look."
    },
    {
      stepNumber: "Step 05",
      title: "Making Informed Decisions",
      description: "Before making an offer, our team will assist you with due diligence, including property inspections, legal checks, and market analysis."
    },
    {
      stepNumber: "Step 06",
      title: "Getting the Best Deal",
      description: "We'll help you negotiate the best terms and prepare your offer. Our goal is to secure the property at the right price and on favorable terms."
    }
  ];

  return (
    <div className="w-full bg-white py-16 md:py-20 lg:py-24 px-6 md:px-12 lg:px-16 xl:px-20">
      <div className="max-w-6xl mx-auto flex flex-col items-start gap-12 lg:gap-16">
        <div className="flex flex-col items-start gap-2 self-stretch max-w-4xl relative">
          <h1 className="text-primary text-2xl md:text-3xl lg:text-4xl font-semibold leading-[150%] w-full">
            Navigating the Alkina Realty Experience
          </h1>
          <p className="self-stretch text-[#666666] font-medium text-sm md:text-base leading-[150%] font-urbanist">
            At Alkina Realty, we've designed a straightforward process to help you find and purchase your dream property with ease. Here's a step-by-step guide to how it all works.
          </p>
        </div>

        <div className="flex flex-col items-start gap-6 lg:gap-8 self-stretch">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6 self-stretch items-stretch">
            {steps.slice(0, 3).map((step, index) => (
              <ProcessStep
                key={index}
                stepNumber={step.stepNumber}
                title={step.title}
                description={step.description}
              />
            ))}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6 self-stretch items-stretch">
            {steps.slice(3, 6).map((step, index) => (
              <ProcessStep
                key={index + 3}
                stepNumber={step.stepNumber}
                title={step.title}
                description={step.description}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}